/**
 * Converts an imaging API template URL (using `{z}/{x}/{y}` placeholders)
 * to the format expected by web3d tile plugins (`{level}/{x}/{y}`).
 *
 * Splits on the **first** `?` only so signed blob URLs (extra `?` in query
 * values or unusual encoding) and templates **without** a query string still work.
 */
export function buildTilesUrlFromTemplateUrl(templateUrl: string): string {
  const qIdx = templateUrl.indexOf('?');
  const pathPart = qIdx >= 0 ? templateUrl.slice(0, qIdx) : templateUrl;
  const queryPart = qIdx >= 0 ? templateUrl.slice(qIdx + 1) : '';
  const basePath = pathPart.replace('{z}/{x}/{y}', '{level}/{x}/{y}');
  return queryPart.length > 0 ? `${basePath}?${queryPart}` : basePath;
}
